import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import secureLocalStorage from 'react-secure-storage';

import { Box, Stack, Typography } from '@mui/material';

import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

import { topContainerStyles } from 'src/layouts/login/styles';

import Logo from 'src/components/logo/Logo';
import Iconify from 'src/components/iconify';
import LanguagePopover from 'src/components/LanguagePopover';

import ChangePassword from '../../components/changePassword/ChangePassword';

export default function FirstLogin() {
  const { state, search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const token = queryParams.get('token');
  const { userId, oldPassword } = state || {};

  const { t } = useTranslation();
  const { isSmallScreen } = useResponsiveScreen();

  if (!state) {
    secureLocalStorage.removeItem('user');
    secureLocalStorage.removeItem('user_data');
  }

  return (
    <>
      <Helmet>
        <title> Oryx One Ticketing System</title>
      </Helmet>

      <Stack bgcolor="#FFFFFF" height="100%" width="100%">
        <Box sx={{ ...topContainerStyles, p: 1 }}>
          <Logo sx={{ width: 200, height: 'auto', mt: '6px', px: 1 }} />
          <Box
            sx={{
              mr: !isSmallScreen && 5,
            }}
          >
            <LanguagePopover />
          </Box>
        </Box>
        <Stack spacing={2}>
          <Stack>
            <Iconify
              style={{ color: '2b1fd1' }}
              icon="mdi:password-check-outline"
              alignSelf="center"
              sx={{
                width: { xs: '10vh', sm: '18vh', md: '20vh' },
                height: { xs: '3vh', sm: '7vh', md: '8vh' },
              }}
            />
            <Typography
              variant="h4"
              alignSelf="center"
              sx={{
                fontSize: { xs: '1.2rem', sm: '2rem', md: '2.5rem' },
              }}
            >
              {t('pages.firstLogin.chooseNewPWD')}
            </Typography>
          </Stack>
          <Stack>
            <Typography
              width={{ xs: '90%', sm: '75vh' }}
              variant="subtitle1"
              color="rgb(80 85 127)"
              alignSelf="center"
              sx={{
                fontSize: isSmallScreen && '0.7rem',
              }}
            >
              {t('pages.firstLogin.pleaseNewPWD')}
            </Typography>
            <Stack alignItems="center" justifyContent="center" mt={3} mb={2}>
              <ChangePassword userId={userId} oldPass={oldPassword} token={token} />
            </Stack>
          </Stack>
          <Typography
            color="black"
            textAlign="center"
            width="100%"
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
              fontSize: isSmallScreen && '0.7rem',
            }}
          >
            {t('pages.login.poweredBy')}
            <img
              src="/assets/icons/AlgorLeapLogo.svg"
              style={{
                maxWidth: '80%',
                height: 'auto',
                marginTop: '10px',
                width: isSmallScreen ? '80px' : '140px',
              }}
              alt="Algor"
            />
          </Typography>
        </Stack>
      </Stack>
    </>
  );
}
